var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row atom-facts"},_vm._l((_vm.facts),function(fact,index){return _c('div',{key:index,staticClass:"col",class:[`${_vm.columns}`]},[_c('div',{staticClass:"box-fact"},[_c('h5',{domProps:{"innerHTML":_vm._s(_vm.$tdb(fact.title))}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$tdb(fact.content))}})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }